<template>
  <section class="flex min-w-0 flex-col gap-5">
    <div v-if="withHeading" class="flex flex-col gap-1">
      <h2 class="text-lg font-semibold">{{ t('admin.setup.contact.legal.title') }}</h2>
      <p class="text-sm leading-normal text-muted-foreground">
        {{ t('admin.setup.contact.legal.description') }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-rt-name">{{ t('admin.setup.contact.rtName.label') }}</Label>
      <Input id="setup-rt-name" v-model="form.LEGAL_RT_ORGANISME_NAME" autocomplete="organization" />
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-rt-address">{{ t('admin.setup.contact.rtAddress.label') }}</Label>
      <Textarea
        id="setup-rt-address"
        v-model="form.LEGAL_RT_CONTACT_ADDRESS"
        rows="2"
        autocomplete="street-address"
        data-test-id="setup-rt-address-input"
      />
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-dpo-email">{{ t('admin.setup.contact.dpoEmail.label') }}</Label>
      <Input id="setup-dpo-email" v-model="form.LEGAL_RT_DPO_EMAIL" type="email" />
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

withDefaults(defineProps<{ withHeading?: boolean }>(), { withHeading: true })

const { t } = useI18n()
const { form } = usePlatformSetup()
</script>
